/* eslint-disable @typescript-eslint/no-explicit-any */
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { environment } from '../environments/environment';
import { ExtrapagesModule } from './extrapages/extrapages.module';
import { ErrorInterceptor } from './core/helpers/error.interceptor';
import { API_URL, BaseUrlInterceptor } from './core/interceptors/base-url-interceptor.interceptor';
import { TokenInterceptor } from './core/interceptors/token.interceptor';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ToastrModule } from 'ngx-toastr';
import * as envStage from '@env/environment.stage';
import { BusinessCardModule } from './extrapages/business-card/business-card.module';

export function createTranslateLoader(http: HttpClient): any {
  return new TranslateHttpLoader(http, `${envStage.environment.publicUrl}assets/languages/`, '.json');
}
@NgModule({
  declarations: [AppComponent],
  imports: [
    TranslateModule.forRoot({
      defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    BrowserModule,
    AppRoutingModule,
    NgbModule,
    HttpClientModule,
    ExtrapagesModule,
    BusinessCardModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot({
      maxOpened: 2,
    }),
  ],
  providers: [
    { provide: API_URL, useValue: environment.apiUrl },
    { provide: HTTP_INTERCEPTORS, useClass: BaseUrlInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
